<script setup>
import { inject } from "vue"
const view = inject("view", "mobile")
</script>
<template>
  <footer>
    <div v-if="view == 'desktop'" class="footer-logo">
      <img 
        src="/assets/icons/footer-logo.svg" 
        alt="АЭБ"
      />
      <p>© 2024 АКБ «Алмазэргиэнбанк» АО. Генеральная лицензия ЦБ РФ №2602 от 08.06.2015</p>
    </div>
  
    <nav class="footer-nav">
      <div class="footer-nav__top">
        <a href="https://albank.ru/ru/offices/">Офисы</a>
        <a href="https://albank.ru/ru/more/info/exchange/">Курсы валют</a>
        <a href="https://albank.ru/ru/more/info/news/">Новости</a>
        <a href="https://svoi.albank.ru/">Программа лояльности «СВОИ» </a>
        <a href="https://card.sakha.gov.ru">Карта жителя Якутии</a>  
      </div>
      <hr />
      <div class="footer-nav__bottom">
        <router-link to='/privacy-policy'>Пользовательское соглашение</router-link>
        <a href="/Правила об использовании системы дистанционного банковского обслуживания «АЭБ Онлайн».pdf">Условия обслуживания</a>
      </div>
    </nav>
  
    <div class="footer-info">
      <div class="footer-info__item">
        <label>Бесплатная по России</label>
        <a href="tel:88001003422">8 800 100-34-22</a>
      </div>
      <div class="footer-info__item">
        <label>Звонок по Якутии</label>
        <a href="tel:84112342222">8 (4112) 34-22-22</a>
      </div>
      <div class="footer-info__item">
        <label>Электронная почта</label>
        <a href="mailto:bank@albank.ru">bank@albank.ru</a>
      </div>
      <div class="footer-info__item">
        <label>Наш адрес</label>
        <p>г. Якутск, пр. Ленина, 1</p>
      </div>
    </div>
  
    <div class="footer-links">
      <div class="app wrapper">
        <img src="/assets/icons/aeb-app-icon.svg" alt="АЭБ">
        <div class="app-text">
          <h4>АЭБ Онлайн</h4>
          <p>Мобильное приложение для iOS и Android</p>
        </div>
      </div>
      <div class="download">
        <a href="https://apps.apple.com/ru/app/%D0%B0%D1%8D%D0%B1-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-2-0/id1278796871" class="wrapper">
          <img src="/assets/icons/apple-store.png" alt="Apple store">
        </a>
        <a href="https://play.google.com/store/apps/details?id=ru.albank.online.aebit&hl=ru" class="wrapper">
          <img src="/assets/icons/google-play.png" alt="Google play">
        </a>
        <a href="https://appgallery.huawei.com/#/app/C104494399" class="wrapper">
          <img src="/assets/icons/huawei-store.png" alt="Huawei store">
        </a>
        <a href="https://www.rustore.ru/catalog/app/ru.albank.online.aebit" class="wrapper">
          <img src="/assets/icons/ru-store.png" alt="Ru store ">
        </a>
      </div>
    </div>

    <div v-if="view != 'desktop'" class="footer-logo">
      <img 
        src="/assets/icons/footer-logo.svg" 
        alt="АЭБ"
      />
      <p>© 2024 АКБ «Алмазэргиэнбанк» АО. Генеральная лицензия ЦБ РФ №2602 от 08.06.2015</p>
    </div>
  </footer>
</template>

<style lang="scss">

footer {
  gap: 60px;
  width: 90%; 
  display: flex;
  padding: 80px;
  margin-top: 120px;
  margin-bottom: 60px;
  border-radius: 60px;
  background: var(--color-mono-900);

  @media screen and (max-width: 1200px) {
    gap: 40px;
    flex-direction: column;
  }

  @media screen and (max-width: 800px) {
    padding: 24px;
    border-radius: 24px;
    margin-bottom: 24px;
  }
}


.footer {
  &-logo {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    @media screen and (max-width: 1200px) {
      gap: 40px;
    }

    img {
      height: 50px;
    }
  }

  &-nav {
    flex: 1;
    gap: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    a {
      font-weight: var(--font-weight-light);
    }

    hr {
      display: none;

      @media screen and (max-width: 1200px) {
        display: block;
        border: 1px solid var(--color-mono-800);
      }
    }

    &__bottom, &__top {
      gap: 14px;
      display: flex;
      flex-direction: column;
    }
  }

  &-info {
    gap: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 1200px) {
      gap: 12px;
    }

    &__item {
      gap: 6px;
      display: flex;
      flex-direction: column;  

      label {
        font-size: var(--font-size-xs);
        color: var(--color-mono-400);

        @media screen and (max-width: 1200px) {
          font-size: var(--font-size-xxs);
        }
      }

      a, p {
        font-size: 22px;
        color: var(--color-mono-0);

        @media screen and (max-width: 1200px) {
          font-size: var(--font-size-m);
        }
      }
    }
  }

  &-links {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 1200px) {
      gap: 40px;
      align-items: flex-start;
    }

    @media screen and (max-width: 800px) {
      flex-direction: column-reverse;
    }

    .app {
      gap: 16px;
      display: flex;

      @media screen and (max-width: 600px) {
        width: 100%;
      }

      .app-text {
        display: flex;
        flex-direction: column;
        
        h4, p {
          color: var(--color-mono-0);
        }

        h4 {
          font-size: var(--font-size-m);
        }

        p {
          max-width: 180px;
          font-size: var(--font-size-xs);
          font-weight: var(--font-weight-light) !important;
        }
      }
    }

    .wrapper {
      padding: 20px;
      border-radius: 24px;
      background: var(--color-mono-700);

      @media screen and (max-width: 800px) {
        background: var(--color-mono-800);
      }
    }

    .download {
      gap: 16px;
      display: flex;
      
      @media screen and (max-width: 800px) {
        width: 100%;
      }

      a {
        border-radius: 20px;

        img {
          max-width: 32px;
        }

        @media screen and (max-width: 420px) {
          padding: 12px;
          border-radius: 12px;
        }

        @media screen and (max-width: 340px) {
          img {
            max-width: 24px;
          }
        }

      }
    }
  }
}
</style>
